export const prerender = true;
export const trailingSlash = 'always';

import { PUBLIC_BASE_PATH } from '$env/static/public';
import { loadTranslations } from '$lib/translations/translations';

const languages = ['ja', 'zh-cn', 'zh-tw'];

/** @type {import('@sveltejs/kit').Load} */
export const load = async ({ url, params }) =>
{
    let { pathname } = url;
    pathname = pathname.replace(new RegExp(PUBLIC_BASE_PATH), '');
    const firstPathname = pathname.split('/')[1] ?? '';

    let lang = 'ja';
    if (languages.some(lang => lang == firstPathname))
    { // URLが/jaとかから始まってる場合
        lang = firstPathname;
    }

    await loadTranslations(lang, pathname);

    return {};
}
